import {AfterViewInit, Directive, ElementRef, Input, OnInit, Renderer2} from '@angular/core';
import {FormControl, FormControlName, NgControl} from '@angular/forms';
import {FormService} from '../shared/form.service';

@Directive({
  selector: '[formControlName][type=radio]'
})
export class DisabledControlDirective implements AfterViewInit {
  @Input() formControlName: FormControlName;

  constructor(private renderer: Renderer2, public el: ElementRef, private formService: FormService, public control: NgControl) {
  }

  ngAfterViewInit() {
      if (this.control.control?.disabled) {
        this.renderer.setAttribute(this.el.nativeElement, 'disabled', 'true');
      }
  }
}
